import { render, staticRenderFns } from "./distributionDiagram.vue?vue&type=template&id=063e250a&scoped=true"
import script from "./distributionDiagram.vue?vue&type=script&lang=js"
export * from "./distributionDiagram.vue?vue&type=script&lang=js"
import style0 from "./distributionDiagram.vue?vue&type=style&index=0&id=063e250a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e250a",
  null
  
)

export default component.exports